// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"bX-z","sponsoredTooltipWrapper":"cX-z","sponsoredTooltip":"dX-z","newCard":"eX-z"};